export const getSystemVoices = (languageIso, languageCode) => {
  if (!window.clozemaster?.systemTtsAvailable(languageIso, languageCode)) return [];
  return window.clozemaster.getSystemTtsVoices(languageIso, languageCode);
};

const getSystemVoice = (languageIso, languageCode, voiceId) => {
  const voices = getSystemVoices(languageIso, languageCode);
  return voices.find((voice) => voice.voiceURI === voiceId) || voices[0] || null;
};

export const isSystemTtsAvailable = (languageIso, languageCode) => !!getSystemVoice(languageIso, languageCode);

// Plays the sentence's server audio, falling back to the browser's voice. Returns a function that stops it.
export const playSentenceAudio = ({ sentence, rate, languageIso, languageCode, voiceId, onEnded, onError }) => {
  if (sentence.ttsUrl) {
    const audio = new Audio(sentence.ttsUrl);
    audio.playbackRate = rate;
    audio.onended = onEnded;
    audio.play()?.catch(onError);
    return () => {
      audio.onended = null;
      audio.pause();
    };
  }

  const voice = getSystemVoice(languageIso, languageCode, voiceId);
  const utterance = voice && window.clozemaster.playSystemUtterance(sentence.text, voice, rate);
  if (!utterance) {
    onError?.();
    return () => {};
  }
  utterance.onend = onEnded;
  return () => {
    utterance.onend = null;
    window.speechSynthesis.cancel();
  };
};
